import React from 'react';
import { useNavigate } from 'react-router-dom';

const AnnualSavingsPanel = ({ isAnnual, onToggle }) => {
  const navigate = useNavigate();
  const monthlyPrice = 499;
  const annualPrice = 399;
  const annualTotal = annualPrice * 12;
  const monthlyTotal = monthlyPrice * 12;
  const savings = monthlyTotal - annualTotal;
  const savingsPct = Math.round((savings / monthlyTotal) * 100);

  return (
    <section style={{ padding: '80px 48px', background: 'var(--color-background)', position: 'relative', overflow: 'hidden' }}>
      {/* Geometric background */}
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%) rotate(12deg)', width: '600px', height: '600px', border: '1px solid rgba(255,87,34,0.04)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%) rotate(-8deg)', width: '500px', height: '500px', border: '1px solid rgba(0,79,152,0.05)', pointerEvents: 'none' }} />

      <div style={{ maxWidth: '1440px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: '56px' }}>
          <div style={{ display: 'inline-block', background: 'rgba(255,87,34,0.1)', border: '1px solid rgba(255,87,34,0.25)', borderRadius: '2px', padding: '4px 12px', marginBottom: '20px' }}>
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#FF5722' }}>Sparing</span>
          </div>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '36px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '-0.01em', marginBottom: '12px' }}>Månedlig vs. Årlig fakturering</h2>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '15px', color: 'var(--color-muted-foreground)', maxWidth: '440px', margin: '0 auto', lineHeight: 1.6 }}>Velg årlig fakturering og spar betydelig på Premium-abonnementet.</p>
        </div>

        {/* Overlapping panels */}
        <div style={{ position: 'relative', maxWidth: '800px', margin: '0 auto', height: '340px' }}>
          {/* Monthly panel (back) */}
          <div style={{
            position: 'absolute',
            top: '20px',
            left: '0',
            width: '55%',
            background: 'rgba(255,255,255,0.03)',
            border: '1px solid rgba(224,228,232,0.1)',
            borderRadius: '2px',
            padding: '36px 40px',
            backdropFilter: 'blur(4px)',
            zIndex: isAnnual ? 1 : 2,
            transition: 'z-index 0ms',
          }}>
            <div style={{ position: 'absolute', top: '-1px', right: '-1px', width: '24px', height: '24px', borderTop: '2px solid rgba(224,228,232,0.2)', borderRight: '2px solid rgba(224,228,232,0.2)' }} />
            <div style={{ fontFamily: 'var(--font-heading)', fontSize: '12px', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--color-muted-foreground)', marginBottom: '20px' }}>Månedlig fakturering</div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px', marginBottom: '12px' }}>
              <span style={{ fontFamily: 'var(--font-heading)', fontSize: '42px', fontWeight: 700, color: 'var(--color-foreground)', letterSpacing: '-0.02em' }}>kr {monthlyPrice}</span>
              <span style={{ fontFamily: 'var(--font-caption)', fontSize: '15px', color: 'var(--color-muted-foreground)' }}>/mnd</span>
            </div>
            <div style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'var(--color-muted-foreground)', marginBottom: '24px' }}>
              kr {monthlyTotal?.toLocaleString('nb-NO')} per år
            </div>
            <div style={{ height: '1px', background: 'rgba(224,228,232,0.06)', marginBottom: '20px' }} />
            <div style={{ fontFamily: 'var(--font-body)', fontSize: '13px', color: 'rgba(224,228,232,0.4)' }}>Ingen binding — betal måned for måned</div>
          </div>

          {/* Annual panel (front) */}
          <div style={{
            position: 'absolute',
            top: '0',
            right: '0',
            width: '60%',
            background: 'rgba(255,87,34,0.06)',
            border: '2px solid rgba(255,87,34,0.3)',
            borderRadius: '2px',
            padding: '36px 40px',
            backdropFilter: 'blur(8px)',
            zIndex: isAnnual ? 2 : 1,
            boxShadow: '0 8px 32px rgba(255,87,34,0.1)',
          }}>
            <div style={{ position: 'absolute', top: '-2px', right: '-2px', width: '32px', height: '32px', borderTop: '3px solid #FF5722', borderRight: '3px solid #FF5722' }} />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
              <div style={{ fontFamily: 'var(--font-heading)', fontSize: '12px', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#FF5722' }}>Årlig fakturering</div>
              <div style={{ background: '#FF5722', borderRadius: '2px', padding: '3px 10px' }}>
                <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 700, letterSpacing: '0.08em', color: '#FFFFFF' }}>ANBEFALT</span>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px', marginBottom: '4px' }}>
              <span style={{ fontFamily: 'var(--font-heading)', fontSize: '42px', fontWeight: 700, color: '#FF5722', letterSpacing: '-0.02em' }}>kr {annualPrice}</span>
              <span style={{ fontFamily: 'var(--font-caption)', fontSize: '15px', fontWeight: 500, color: 'var(--color-muted-foreground)' }}>/mnd</span>
            </div>
            <div style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'var(--color-muted-foreground)', marginBottom: '8px' }}>
              kr {annualTotal?.toLocaleString('nb-NO')} per år
            </div>
            {/* Savings highlight */}
            <div style={{ background: 'rgba(255,87,34,0.1)', border: '1px solid rgba(255,87,34,0.2)', borderRadius: '2px', padding: '12px 16px', marginBottom: '20px' }}>
              <div style={{ fontFamily: 'var(--font-heading)', fontSize: '24px', fontWeight: 700, color: '#FF5722', letterSpacing: '-0.01em' }}>Spar {savingsPct}%</div>
              <div style={{ fontFamily: 'var(--font-body)', fontSize: '14px', fontWeight: 500, color: 'var(--color-muted-foreground)', marginTop: '2px' }}>= kr {savings?.toLocaleString('nb-NO')} spart per år</div>
            </div>
            <button
              onClick={() => { onToggle(); navigate('/register'); }}
              style={{
                width: '100%',
                background: '#FF5722',
                border: '2px solid #FF5722',
                borderRadius: '2px',
                padding: '13px 20px',
                fontFamily: 'var(--font-heading)',
                fontSize: '13px',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: '#FFFFFF',
                cursor: 'pointer',
                transition: 'background 200ms ease',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = '#E64A19'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#FF5722'; }}
            >
              Start med årlig plan
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnnualSavingsPanel;
